/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.side-pad[_ngcontent-%COMP%]{\n    padding-left: 20px !important;\n    padding-right: 20px !important;\n}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3ZlcmNlbC93b3JrcGF0aDAvc3JjL2FwcC91c2VyLW1hbmFnZW1lbnQvdXNlci1wYXNzd29yZC91c2VyLXBhc3N3b3JkLmNvbXBvbmVudC5jc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vdmVyY2VsL3dvcmtwYXRoMC9zcmMvYXBwL3VzZXItbWFuYWdlbWVudC91c2VyLXBhc3N3b3JkL3VzZXItcGFzc3dvcmQuY29tcG9uZW50LnRzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/app/user-management/user-password/user-password.component.css.shim.ngstyle.ts